<template>
  <div
    class="legend u-bg-white u-black u-pad-md u-pointer-all"
    :class="{
      'legend--track': isTracking,
      'legend--track--left': position.x < this.$device.width * .5,
      'legend--track--top': position.y > this.$device.height * .5
    }"
    :style="{transform: isTracking ? `translate3d(${position.x}px, calc(${position.y + 20}px + 50%), 0)` : `translateZ(0)`}"
  >
    <div class="t-h2 u-marg-b-sm">
      {{ subtitle }}
    </div>
    <div class="t-h1 u-marg-b-sm">
      {{ title }}
    </div>
    <div class="t-text">
      {{ text }}
    </div>
    <cta v-if="cta.label && cta.link && cta.color" :label="cta.label" :href="cta.link" :color="cta.color" class="t-h1 u-marg-t-md" />
  </div>
</template>

<script>
import Cta from '@/components/common/Cta'

export default {
  components: {
    Cta
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    cta: {
      type: Object,
      default: {}
    },
    isTracking: {
      type: Boolean,
      default: true
    },
    position:  {
      type: Object,
      default: {x: 0, y: 0}
    }
  },

  computed: {
    class () {
      const pos = ''

      if (position.x < this.$device.width * .5) {
        pos += 'legend--left'
      }

      if (position.z < this.$device.height * .5) {
        pos += 'legend--left'
      }
    }
  }
}  
</script>

<style lang="stylus">

.legend
  position absolute
  top 0
  right 0
  width 25%
  height 100%

  &--track
    position absolute
    top 0
    left -150px
    right auto
    width 300px
    height auto
    border-radius 10px
    
  &--track--top
    top -15%
    left 5%
    right auto
    

    &:after
      content none !important
  
  &:after
    content ''
    opacity .2
    position absolute
    top 0
    right 100%
    width 100px
    height 100%
    background linear-gradient(to left, black, transparent)

</style>